import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map, catchError } from 'rxjs';
import { BASE_PATH } from '@app/api';
import {
  SyncErrorReportSearchParams,
  SyncLogItem,
} from '../sync-report.config';

export interface SyncErrorReportResponse {
  data: SyncLogItem[];
  totalRecords: number;
}

/**
 * Wraps GET /v1/goods/sync-log (goods-service, RBA-2266 / RBA-3104) directly via HttpClient rather
 * than an OpenAPI-generated client: the generated client under src/app/api/goods-service is only
 * regenerated (`npm run api:generate --service goods-service`) against develop's deployed spec, and
 * this endpoint hasn't merged there yet. Once it has, regenerate the client and switch this service
 * to wrap the generated GoodsSyncLogControllerService instead, following the sku-real-api.service.ts
 * pattern used elsewhere in this module.
 */
@Injectable({
  providedIn: 'root',
})
export class SyncReportService {
  private readonly httpClient = inject(HttpClient);
  private readonly basePath = inject(BASE_PATH);

  getSyncErrorReport(
    params: SyncErrorReportSearchParams,
  ): Observable<SyncErrorReportResponse> {
    let httpParams = new HttpParams()
      .set('page', String(params.page ?? 0))
      .set('size', String(params.size ?? 20));

    if (params.eventType) {
      httpParams = httpParams.set('eventType', params.eventType);
    }
    if (params.schemaVersion) {
      httpParams = httpParams.set('schemaVersion', params.schemaVersion);
    }
    if (params.result) {
      httpParams = httpParams.set('result', params.result);
    }
    if (params.entityType) {
      httpParams = httpParams.set('entityType', params.entityType);
    }
    if (params.dateFrom) {
      httpParams = httpParams.set('dateFrom', params.dateFrom);
    }
    if (params.dateTo) {
      httpParams = httpParams.set('dateTo', params.dateTo);
    }

    return this.httpClient
      .get<any>(`${this.basePath}/v1/goods/sync-log`, {
        params: httpParams,
      })
      .pipe(
        map((response) => ({
          data: (response?.pageContent ?? []) as SyncLogItem[],
          totalRecords: response?.totalElements ?? 0,
        })),
        catchError((error) => {
          console.error('Error fetching sync report:', error);
          throw error;
        }),
      );
  }
}
